module.exports = __webpack_public_path__ + "static/media/open-source-500x500.d4a80ddf.png";